export const animals = [
  { id: 1, name: "dog", img: "🐶" },
  { id: 2, name: "penguin", img: "🐧" },
  { id: 4, name: "tiger", img: "🐯" },
  { id: 6, name: "lion", img: "🦁" },
  { id: 7, name: "pig", img: "🐷" },
  { id: 8, name: "fox", img: "🦊" },
  { id: 9, name: "panda", img: "🐼" },
  { id: 10, name: "horse", img: "🐴" },
  { id: 11, name: "hamster", img: "🐹" },
  { id: 12, name: "owl", img: "🦉" },
  { id: 13, name: "monkey", img: "🐵" },
  { id: 14, name: "octopus", img: "🐙" },
  { id: 15, name: "corcodile", img: "🐊" },
  { id: 16, name: "chicken", img: "🐔" },
  { id: 17, name: "koala", img: "🐨" },
  { id: 18, name: "frog", img: "🐸" },
  { id: 19, name: "doplphin", img: "🐬" },
];
